import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { useFormTcfVendor } from "../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../contexts/i18n.js";
import { LearnMoreTag } from "../../../common/learnMoreTag.js";
import { FormServiceLayout } from "../../layout.js";
const FormTcfVendorFieldTemplateCheck = ()=>{
    const { __, _x } = useI18n();
    const { isEdit } = useFormTcfVendor();
    return !isEdit && /*#__PURE__*/ _jsx(Form.Item, {
        name: "templateCheck",
        valuePropName: "checked",
        required: true,
        rules: [
            {
                type: "boolean",
                required: true,
                transform: (value)=>value || undefined,
                message: __("Please confirm that you have checked the contents of the service.")
            }
        ],
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span
        },
        children: /*#__PURE__*/ _jsxs(Checkbox, {
            children: [
                _x("I have checked the information in the TCF vendor configuration myself and corrected any information that does not fit to my use case.", "legal-text"),
                " ",
                /*#__PURE__*/ _jsx(LearnMoreTag, {
                    url: __("https://devowl.io/knowledge-base/is-real-cookie-banner-legally-compliant/")
                })
            ]
        })
    });
};
export { FormTcfVendorFieldTemplateCheck };
